<sd-6-17-1-dialog
  #dialog
  [headline]="headline | transloco"
  (afterHide)="onAfterHide()">
  <div class="save-filter-template-dialog">
    <sd-6-17-1-input
      #nameInput
      lang="de"
      [label]="nameLabel | transloco"
      size="md"
      [placeholder]="'Vorlage ' + nextTemplateName()"
      [value]="name()"></sd-6-17-1-input>

    <sd-6-17-1-checkbox
      #autoLoadInput
      [checked]="autoLoad()">
      {{ autoLoadLabel | transloco }}
    </sd-6-17-1-checkbox>

    @if (filterValues().length > 0) {
      <div class="selected-summary">
        <p class="sd-meta sd-meta--size-sm">{{ activeFiltersHeading | transloco }}</p>
        <ul>
          @for (value of filterValues(); track $index) {
            <li>{{ value.key }}: {{ (value.values ?? []).join(', ') }}</li>
          }
        </ul>
      </div>
    }

    <div class="dialog-actions">
      <sd-6-17-1-button
        variant="tertiary"
        type="button"
        (click)="cancel()">
        {{ cancelLabel | transloco }}
      </sd-6-17-1-button>
      <sd-6-17-1-button
        wctLoadingIndicator
        [apiCallAdditionalLoading]="saving"
        variant="primary"
        type="button"
        [disabled]="!canSave"
        (click)="confirm()">
        {{ confirmLabel | transloco }}
      </sd-6-17-1-button>
    </div>
  </div>
</sd-6-17-1-dialog>

